module.exports = __webpack_public_path__ + "img/MetalArmorMark2.13dc781a.gif";